<!-- TODO: Implement iframe binding in Task 4 -->
<ng-container *ngIf="safeReplitUrl; else loadingOrError">
  <iframe
    #replitIframe
    [src]="safeReplitUrl"
    sandbox="allow-scripts allow-same-origin"
    class="lum-c-embed-replit__iframe"
  ></iframe>
</ng-container>

<ng-template #loadingOrError>
  <!-- Step 4.4: Placeholder content while loading or if there's an error -->
  <div class="lum-c-embed-replit__message">
    <p *ngIf="!safeReplitUrl">Loading Replit application...</p>
    <!-- Add more specific error handling/message if needed based on component state -->
  </div>
</ng-template>
